<template>
    <div>
        <div class="head-bar">
            <el-input v-model="datas.add.user_id" placeholder="UID" clearable></el-input>
            <el-input v-model="datas.add.field" placeholder="field" clearable></el-input>
            <el-input v-model="datas.add.kw" placeholder="关键词" clearable></el-input>
        </div>
        <el-table v-loading="datas.status == -1" :data="datas.data" @sort-change="_sort" @selection-change="_select">
            <!-- <el-table-column prop="id" label="ID" sortable></el-table-column> -->
            <el-table-column prop="title" label="说明"></el-table-column>
            <el-table-column prop="user_name" label="用户"></el-table-column>
            <el-table-column prop="amount" label="金额"></el-table-column>
            <el-table-column prop="c_amount" label="当前金额"></el-table-column>
            <el-table-column prop="field_text" label="字段"></el-table-column>
            <el-table-column prop="create_time" label="时间" :formatter="_table_time" width="150"></el-table-column>
        </el-table>
        <div class="page-box">
            <el-pagination @size-change="_size" @current-change="_page" :current-page="datas.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="datas.limit" layout="total, sizes, prev, pager, next"
                :total="datas.total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            table: 'account_log',
            datas: {
                add: {
                    append: ['field_text']
                }
            }
        };
    },
    created() {
        this.datas.add = {
            ...this.datas.add,
            ...this.$route.query || {}
        };
        this._load();
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>